import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { PatientUiTermsOfServiceToMfaEdge } from '@app/registration/graph/edges/__generated__/terms-of-service-to-mfa-edge-graphql.service.types';

@Injectable({
  providedIn: 'root',
})
export class TermsOfServiceToMfaEdgeGraphqlService extends Query<PatientUiTermsOfServiceToMfaEdge> {
  document = gql`
    query PatientUITermsOfServiceToMfaEdge {
      patient {
        id
        multiFactorAuthentication {
          enabled
        }
        hasClaimedAccessKey
      }
    }
  `;
}
